/**
 * Access to the header's DOM elements.
 */
import dom from '../../../helpers/dom';
import adminBar from './adminBar';

const headerElements = () => {
  // @todo Replace with `js-` classes.
  const headerClass = 'qusd-header';
  const mobileHeaderClass = 'qusd-header-mobile';
  const desktopHeaderClass = 'qusd-header-desktop';
  /*
   * These elements are used as catch-all containers for sticky elements.
   * Elements inside these containers are displayed below the header, while
   * not interfering with the display of the dropdown/toggle menus.
   */
  const mobileStickyContainerClass = 'js-header-mobile-behind-menu';
  const desktopStickyContainerClass = 'js-header-desktop-behind-dropdown';

  let headerElement;
  let headerFound = false;
  let headerHeight = 0;
  let mobileHeaderElement;
  let desktopHeaderElement;
  let mobileStickyContainerElement;
  let desktopStickyContainerElement;

  const init = () => {
    adminBar.init();
    headerElement = document.querySelector(dom.classNameToSelector(headerClass));
    headerFound = headerElement !== null;

    if (headerFound) {
      headerHeight = headerElement.offsetHeight;

      mobileHeaderElement = headerElement.querySelector(
        dom.classNameToSelector(mobileHeaderClass),
      );
      desktopHeaderElement = headerElement.querySelector(
        dom.classNameToSelector(desktopHeaderClass),
      );
      mobileStickyContainerElement = mobileHeaderElement.querySelector(
        dom.classNameToSelector(mobileStickyContainerClass),
      );
      desktopStickyContainerElement = desktopHeaderElement.querySelector(
        dom.classNameToSelector(desktopStickyContainerClass),
      );
    }
  };

  const onResize = () => {
    adminBar.onResize();
    if (headerFound) {
      headerHeight = headerElement.offsetHeight;
    }
  };

  return {
    getAdminBar: () => adminBar.getElement(),
    adminBarDisplayed: () => adminBar.isDisplayed(),
    adminBarIsSticky: () => adminBar.isSticky(),
    getHeader: () => headerElement,
    hasHeader: () => headerFound,
    getMobileHeader: () => mobileHeaderElement,
    getDesktopHeader: () => desktopHeaderElement,
    getMobileStickyContainer: () => mobileStickyContainerElement,
    getDesktopStickyContainer: () => desktopStickyContainerElement,
    getHeight: () => headerHeight,
    init,
    onResize,
  };
};

export default headerElements();
